var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalPath(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7578 8.36714V2H17.125V8.36714",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77344 8.36719H21.0995V22.6933C21.0995 24.4562 19.6789 25.8899 17.9161 25.906L10.0882 25.9778C8.26246 25.9945 6.77344 24.5191 6.77344 22.6933V8.36719Z",
    stroke: "#215250",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3566 17.3082H21.1016V8.38501H24.9158C35.1169 8.38501 43.3866 16.6547 43.3866 26.8558V35.4268L34.6101 35.4272V27.5615C34.6101 21.8988 30.0194 17.3082 24.3566 17.3082Z",
    stroke: "#215250",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3885 43.3864H22.6953V35.4275H43.3885V43.3864Z",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17969 35.4275H22.6893",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6932 43.3865H2",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalPath);
export default __webpack_public_path__ + "static/media/digital-path.d79c8cf7149dd22088f0aba2190df41f.svg";
export { ForwardRef as ReactComponent };